import { LMTWidgetElement } from "@data-types/live-widget/LMTWidgetElement";
import { LiveWidgetTypes } from "@data-types/live-widget/LiveWidgetTypes";

export const isLMTWidget = (widget: any): widget is LMTWidgetElement =>
	widget?.type === LiveWidgetTypes.LMT;
